import React, { memo } from 'react'
import { Dimensions, Platform, View } from 'react-native'
import { Colors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'
import AddOnsCard from '@vfgroup-oneplatform/framework/AddOns/Components/AddOnsCard'
import PropTypes from 'prop-types'

import VfText from '../VfText'

// import { Images } from '../../Themes'
import { getThemeImages } from '../../Themes/Modes'
import styles from './ListItem.Styles'

function ListItem({ name, price, unit, duration, icon, label, onPress, isLast }) {
  const withLabel = Boolean(label)
  const theme = useTheme()
  const Images = getThemeImages(theme.name)

  if (!name || !price || !icon) {
    return null
  }

  const { width } = Dimensions.get('window')
  let style = {}
  if ((width * 0.8) - 300 > 750) {
    style.minWidth = `${(((width - 300) * 0.8) / 2)}px`
  } else {
    style.width = '100%'
  }

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <View style={[style, { alignSelf: 'flex-end', cursor: 'pointer' }]}>
        {withLabel && (
          <View style={styles.label}>
            <VfText
              i18nKey={label}
              color={Colors.white}
              weight="bold"
            />
          </View>
        )}
        <AddOnsCard
          onPress={() => onPress()}
          item={{
            name,
            price: `${price || ''}${unit || ''}`,
            icon,
            duration,
          }}
          images={Images}
          style={styles.card(withLabel, isLast)}
          secondTextStyle={{
            fontSize: 18.7,
            lineHeight: 25,
            fontWeight: 700
          }}
        />
      </View>
    )
  }

  return (
    <>
      {withLabel && (
        <View style={styles.label}>
          <VfText
            i18nKey={label}
            color={Colors.white}
            weight="bold"
          />
        </View>
      )}
      <AddOnsCard
        onPress={() => onPress()}
        item={{
          name,
          price: `${price || ''}${unit || ''}`,
          icon,
          duration,
        }}
        images={Images}
        style={styles.card(withLabel)}
      />
    </>
  )
}

ListItem.defaultProps = {
  icon: 'icon',
  onPress: () => { },
}

ListItem.propTypes = {
  name: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  unit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  icon: PropTypes.string,
  duration: PropTypes.string,
  label: PropTypes.string,
  onPress: PropTypes.func,
}

export default memo(ListItem)
